<script setup lang="ts">
useDefaultMeta({
  title: 'Dashboard Member | KiriminAja',
  description:
    'Kelola pengiriman, laporan COD, dan performa bisnis Anda dalam satu tampilan. Insight real-time untuk keputusan lebih cepat dan terukur.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu Dashboard COD & Pengiriman KiriminAja?',
    answer:
      'Dashboard Member KiriminAja adalah pusat kendali untuk memantau pengiriman, laporan COD, performa tim, dan analisis pelanggan secara real-time.'
  },
  {
    question: 'Apakah Dashboard ini cocok untuk perusahaan besar?',
    answer:
      'Ya, mendukung struktur multi-cabang dan multi-user untuk operasional berskala korporasi.'
  },
  {
    question: 'Bagaimana cara melihat laporan COD?',
    answer:
      'Anda dapat melihat status pencairan, nominal tertahan, dan riwayat COD langsung dari Beranda dan menu "Laporan Saldo".'
  },
  {
    question: 'Apakah Dashboard ini bisa diakses lewat API atau Plugin?',
    answer:
      'Bisa. Dashboard Member terintegrasi langsung dengan API & Plugin KiriminAja tanpa setup tambahan.'
  },
  {
    question: 'Apakah ada biaya tambahan untuk fitur Dashboard?',
    answer:
      'Tidak ada biaya tambahan bagi pengguna KiriminAja aktif. Semua fitur sudah tersedia dalam akun Anda.'
  }
]

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'KiriminAja Dashboard',
  operatingSystem: 'Desktop',
  applicationCategory: 'BusinessApplication',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 4.2,
    ratingCount: 10135
  },
  offers: {
    '@type': 'Offer',
    price: 0
  }
}

useHead({
  script: [
    {
      key: 'ld-software-application-web',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema)
    }
  ]
})
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Dashboard dan Manajemen Pengiriman Terpadu untuk mengendalikan logistik di bisnis"
      sub-title="Dashboard Member"
      description="Kelola pengiriman, laporan, data pelanggan, dan performa logistik Anda dalam satu tampilan. Insight real-time untuk keputusan lebih cepat dan terukur."
      hero-image="/images/dashboard-member-banner-1.webp"
      button-label="Masuk ke Dashboard Member"
      :button-link="$utm.utmUrl('/login')"
    />

    <SolusiDashboardMemberSection1 />
    <SolusiDashboardMemberSection2 />
    <SolusiDashboardMemberSection4 />
    <SolusiDashboardMemberSection3 />
    <FaqBase :faqs="faqs" />
    <SolusiDashboardMemberCta />
  </div>
</template>
